import angular from 'angular';


import UploadDocumentsModal from './uploadDocumentsModal';

import ESignDocumentsController from './esignDocumentsController';
import FundingDocumentsController from './fundingDocumentsController';
import DocumentLinkFactory from './documentLinkFactory';


export default angular.module('app.appDetail.documents', [
    UploadDocumentsModal,
])
    .controller('EsignDocumentsController', ESignDocumentsController)
    .controller('FundingDocumentsController', FundingDocumentsController)
    .factory('DocumentLink', DocumentLinkFactory)
    .run(($templateCache) => {
        $templateCache.put('app/appDetail/documents/disabledDocuments.html', require('./disabledDocuments.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/esignDocumentsTemplate.html', require('./esignDocumentsTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/financialDocumentsTemplate.html', require('./financialDocumentsTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/fundingDocumentsTemplate.html', require('./fundingDocumentsTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/invalidDocumentsTemplate.html', require('./invalidDocumentsTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/otherDocumentsTemplate.html', require('./otherDocumentsTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/index.js